import { Container, Nav, Navbar } from "react-bootstrap";
import { useCallback, useState } from "react";
import { Link } from "react-router-dom";

import { ReactComponent as DonateIcon } from "../../assets/icons/DonateIcon.svg";
import LoggedInDropdown from "./LoggedInDropdown";
import Logo from "../Logo";
import NavLink from "./NavLink";
import NavigationOffcanvas from "./NavigationOffcanvas";

import { ReactComponent as LwcIcon } from "../../assets/images/lwc-tm-logo.svg";
import { ReactComponent as UserIcon } from "../../assets/icons/UserIcon.svg";

import "./Navigation.scss";

import { Responsive } from "../Devices";
import mainMenu from "./mainMenu.json";
import topBarMenu from "./topBarMenu.json";
import { useAuth } from "../../services/wp.auth.service";

const Navigation = () => {
	const { user } = useAuth();

	const [showOffcanvas, setShowOffcanvas] = useState(false);
	const toggleOffcanvas = useCallback(() => setShowOffcanvas((show) => !show), []);

	return (
		<Navbar
			bg="dark"
			className="py-0"
			expand="lg"
			id="main-navigation"
			variant="dark"
		>
			<Container className="px-0" fluid>
				<Navbar.Brand as={Link} className="bg-dark me-0 py-lg-4 py-2" to="/">
					<Logo className="px-2 pe-3" />
					<Responsive>
						<div className="text-center px-2">
							<LwcIcon />
						</div>
					</Responsive>
				</Navbar.Brand>

				<Navbar.Toggle aria-controls="offcanvasNavbar" className="me-3 border-0" onClick={toggleOffcanvas} />

				<NavigationOffcanvas show={showOffcanvas} toggleShow={toggleOffcanvas} />

				<Container className="mx-0 my-0 px-0 d-xs-none d-none d-lg-block" fluid>
					<Navbar bg="darkblue" className="py-0">
						<Nav className="me-auto">
							{ topBarMenu.map((item) => (
								<NavLink
									className="fw-bold py-3 px-4"
									href={item.href}
									key={item.slug}
									to={item.to}
								>
									{item.name}
								</NavLink>
							))}
						</Nav>

						<Nav>
							<Nav.Link
								className="fw-bold bg-lightblue py-3 px-4 donate-button"
								href="https://www.lifewithcancer.org/get-involved/ways-to-donate/"
								target="_blank"
							>
								<DonateIcon />

								{"Donate"}
							</Nav.Link>

							{
								user
									? <LoggedInDropdown />
									: (
										<>
											<Nav.Link as={Link} className="fw-bold py-3 px-4" to="/login/register">
												Sign Up
											</Nav.Link>
											<Nav.Link as={Link} className="fw-bold py-3 px-4 bg-dark" to="/login">
												<UserIcon className="mr-4" />
												Log In
											</Nav.Link>
										</>)
							}
						</Nav>
					</Navbar>

					<Nav className="bg-primary ps-2">
						{ mainMenu.map((item) => (
							<NavLink
								className="py-3 px-3"
								href={item.href}
								key={item.slug}
								to={item.to}
							>
								{item.name}
							</NavLink>
						))}
						<div className="flex-fill" />
						<Navbar.Brand as={Link} className="d-flex align-items-center" to="/">
							<LwcIcon />
						</Navbar.Brand>
					</Nav>
				</Container>
			</Container>
		</Navbar>
	);
};

export default Navigation;
